import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { ShieldCheckIcon } from 'lucide-react';
interface LoginProps {
  onLogin: () => void;
}
export function Login({
  onLogin
}: LoginProps) {
  const {
    colors
  } = useTheme();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onLogin();
  };
  return <div className="min-h-screen flex items-center justify-center p-4" style={{
    backgroundColor: colors.background
  }} data-id="element-252">
      <div className="w-full max-w-md space-y-8" data-id="element-253">
        <div className="text-center" data-id="element-254">
          <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4" style={{
          backgroundColor: colors.accent
        }} data-id="element-255">
            <ShieldCheckIcon size={40} color="#FFFFFF" data-id="element-256" />
          </div>
          <h1 className="text-3xl font-bold mb-2" style={{
          color: colors.textPrimary
        }} data-id="element-257">
            Welcome Back
          </h1>
          <p style={{
          color: colors.textSecondary
        }} data-id="element-258">
            Sign in to continue to CDSS
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-259">
          <div data-id="element-260">
            <label className="block text-sm font-medium mb-2" style={{
            color: colors.textPrimary
          }} data-id="element-261">
              Email Address
            </label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full p-4 rounded-lg" style={{
            backgroundColor: colors.cardSurface,
            color: colors.textPrimary,
            border: `1px solid ${colors.divider}`
          }} placeholder="Enter your email" required data-id="element-262" />
          </div>
          <div data-id="element-263">
            <label className="block text-sm font-medium mb-2" style={{
            color: colors.textPrimary
          }} data-id="element-264">
              Password
            </label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full p-4 rounded-lg" style={{
            backgroundColor: colors.cardSurface,
            color: colors.textPrimary,
            border: `1px solid ${colors.divider}`
          }} placeholder="Enter your password" required data-id="element-265" />
          </div>
          <button type="submit" className="w-full p-4 rounded-lg font-semibold" style={{
          backgroundColor: colors.accent,
          color: '#FFFFFF'
        }} data-id="element-266">
            Sign In
          </button>
        </form>
      </div>
    </div>;
}